import { backendUrl } from "../backendUrl";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useDialogs } from "../DialogContext";
import "./OrderForm.css";
import axios from "axios";
import SpecialOptions from "../3/SpecialOptions";
// import { apiServer } removed - using backendUrl instead

import { Link } from "react-router-dom";

interface rechnungAdresse {
  vorname: string;
  nachname: string;
  firma: string;
  kundenummer: string;
  email: string;
  streetAndHouse: string;
  zipCode: string;
  city: string;
  land: string;
  telephone: string;
  fax: string;
}

interface liferAdresse {
  vorname: string;
  nachname: string;
  firma: string;
  streetAndHouse: string;
  zipCode: string;
  city: string;
  land: string;
}

interface email {
  id: string;
  rechnungAdresse: rechnungAdresse[];
  liferAdresse: liferAdresse[];
}
function isValidEmail(email: string): boolean {
  // Domena najwyższego poziomu bez limitu długości (.hamburg, .immobilien) i "+" w nazwie (max+shop@...)
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
}
const OrderForm = () => {
  // K1: komunikaty w stronie zamiast systemowych alert
  const { notify } = useDialogs();
  const getStoredData = (key: string, defaultValue: any) => {
    const storedData = localStorage.getItem(key);
    return storedData ? JSON.parse(storedData) : defaultValue;
  };
  const [sendToOtherAddress, setSendToOtherAddress] = useState(false);
  const [buttonColor, setButtonColor] = useState("#005CA9");
  const [emailError, setEmailError] = useState(false);
  // Po pierwszej nieudanej próbie wysyłki błędne pola są oznaczane na bieżąco
  const [showValidation, setShowValidation] = useState(false);
  const [continueStep] = useState(false);
  const [waitForSend, setWaitForSend] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [accept, setAccept] = useState(false);
  const [acceptAlert, setAcceptAlert] = useState(false);

  const [rechnungAdresses, setRechnungAdresse] = useState<rechnungAdresse[]>(
    getStoredData("rechnungAdresse", [
      {
        vorname: "",
        nachname: "",
        firma: "",
        kundenummer: "",
        email: "",
        streetAndHouse: "",
        zipCode: "",
        city: "",
        land: "",
        telephone: "",
        fax: "",
      },
    ])
  );
  const [liferAdresse, setLiferAdresse] = useState<liferAdresse[]>(
    getStoredData("liferAdresse", [
      {
        vorname: "",
        nachname: "",
        firma: "",
        streetAndHouse: "",
        zipCode: "",
        city: "",
        land: "",
      },
    ])
  );

  const storeData = (key: string, data: any) => {
    localStorage.setItem(key, JSON.stringify(data));
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    // Zapisuj dane do localStorage po każdej zmianie
    storeData("rechnungAdresse", rechnungAdresses);
    storeData("liferAdresse", liferAdresse);
  }, [rechnungAdresses, liferAdresse]);

  const handleRechnungAdresseChange = (
    index: number,
    field: keyof rechnungAdresse,
    value: string
  ) => {
    const updatedRechnungAdresse = [...rechnungAdresses];
    if (field === "email") {
      if (!isValidEmail(value)) {
        setEmailError(true);
      } else {
        setEmailError(false);
      }
    }
    updatedRechnungAdresse[index][field] = value as never;
    setRechnungAdresse(updatedRechnungAdresse);
  };

  const handleLiferAdresse = (
    index: number,
    field: keyof liferAdresse,
    value: string
  ) => {
    const updatedLiferAdresse = [...liferAdresse];
    updatedLiferAdresse[index][field] = value as never;
    setLiferAdresse(updatedLiferAdresse);
  };

  const handleEmailSendOrder = () => {
    if (emailError) {
      notify("Bitte geben Sie eine gültige E-Mail-Adresse ein.", "error");
      return;
    }
    const data: email = {
      id: String(localStorage.getItem("mongoID")),
      rechnungAdresse: rechnungAdresses,
      liferAdresse: liferAdresse,
    };
    setButtonColor("#116DBA");
    setTimeout(() => {
      setButtonColor("#005CA9");
    }, 1000);
    const send = async () => {
      setWaitForSend(true)
      try {
        await axios.post(
          `${backendUrl}/api/v1/configurator/email/order`,
          [data]
        );
        setSendEmail(true)
        // alert(
        //   response.data === "Wiadomości email wysłane"
        //     ? "E-Mail wurde gesendet"
        //     : response.data
        // );
        window.location.href =
          "https://www.wplusm.de/de/danke-fuer-schliessplanbestellung/";
      } catch (error) {
        setWaitForSend(false);
        notify("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.", "error");
        console.error("Błąd podczas wysyłania email:", error);
      }
    };
    send();
  };
  const handleEmailSendContact = () => {
    if (emailError) {
      notify("Bitte geben Sie eine gültige E-Mail-Adresse ein.", "error");
      return;
    }
    const data: email = {
      id: String(localStorage.getItem("mongoID")),
      rechnungAdresse: rechnungAdresses,
      liferAdresse: liferAdresse,
    };
    setButtonColor("#116DBA");
    setTimeout(() => {
      setButtonColor("#005CA9");
    }, 1000);
    const send = async () => {
      try {
        setWaitForSend(true)
        await axios.post(
          `${backendUrl}/api/v1/configurator/email/contact`,
          [data]
        );
        setSendEmail(false)
        // alert(
        //   response.data === "Wiadomości email wysłane"
        //     ? "E-Mail wurde gesendet"
        //     : response.data
        // );
        window.location.href =
          "https://www.wplusm.de/de/danke-fuer-anfrage-fuer-schliessanlage/";
      } catch (error) {
        setWaitForSend(false);
        notify("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.", "error");
        console.error("Błąd podczas wysyłania email:", error);
      }
    };
    send();
  };

  // Klucze pól ("billing.vorname", "delivery.city", ...) odpowiadają atrybutom data-field inputów
  const getInvalidFields = (): string[] => {
    const invalid: string[] = [];
    const billing = rechnungAdresses[0];
    if (!billing?.vorname?.length) invalid.push("billing.vorname");
    if (!billing?.nachname?.length) invalid.push("billing.nachname");
    if (!billing?.email?.length || emailError) invalid.push("billing.email");
    if (!billing?.streetAndHouse?.length) invalid.push("billing.streetAndHouse");
    if ((billing?.zipCode ?? "").length <= 3) invalid.push("billing.zipCode");
    if (!billing?.city?.length) invalid.push("billing.city");

    if (sendToOtherAddress) {
      const delivery = liferAdresse[0];
      if (!delivery?.vorname?.length) invalid.push("delivery.vorname");
      if (!delivery?.nachname?.length) invalid.push("delivery.nachname");
      if (!delivery?.streetAndHouse?.length) invalid.push("delivery.streetAndHouse");
      if ((delivery?.zipCode ?? "").length <= 3) invalid.push("delivery.zipCode");
      if (!delivery?.city?.length) invalid.push("delivery.city");
    }
    return invalid;
  };

  const handleValidForm = (): boolean => {
    const invalid = getInvalidFields();
    if (invalid.length === 0) return true;

    setShowValidation(true);
    notify("Bitte füllen Sie die rot markierten Pflichtfelder korrekt aus.", "error");
    const firstInvalid = document.querySelector<HTMLInputElement>(`[data-field="${invalid[0]}"]`);
    firstInvalid?.scrollIntoView({ behavior: "smooth", block: "center" });
    firstInvalid?.focus({ preventScroll: true });
    return false;
  };

  const invalidFields = showValidation ? new Set(getInvalidFields()) : new Set<string>();
  const fieldValidationProps = (key: string) => ({
    "data-field": key,
    className: invalidFields.has(key) ? "input-invalid" : undefined,
    "aria-invalid": invalidFields.has(key) || undefined,
  });
  return (
    <>
      <div
        className="order-form-container"
        style={{
          width: "75%",
          margin: "65px auto 0",
          border: "1px solid #ccc",
          padding: "20px",
        }}
      >
        <div
          className="order-form-header"
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            marginBottom: "20px",
            background: "#005CA9",
            color: "#FFFFFF",
            padding: "10px",
            marginLeft: "-20px",
            marginRight: "-20px",
            marginTop: "-20px",
            fontWeight: "bold",
          }}
        >
          <div style={{ flex: 1 }}>RECHNUNGSADRESSE</div>
          <div>1/2</div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className="billing-column">
          <form>
            {/* Wiersz 1: Vorname | Nachname */}
            <div
              className="form-row-two"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
                width: "100%",
              }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "48%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Vorname*
                </label>
                <input
                  type="text"
                  placeholder="Vorname"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.vorname")}
                  value={rechnungAdresses[0]?.vorname}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "vorname", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "48%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Nachname*
                </label>
                <input
                  type="text"
                  placeholder="Nachname"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.nachname")}
                  value={rechnungAdresses[0]?.nachname}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "nachname", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
            </div>

            {/* Wiersz 2: Firma (pełna szerokość) */}
            <div
              className="form-row-full"
              style={{ display: "flex", marginBottom: "10px", width: "100%" }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Firma
                </label>
                <input
                  type="text"
                  placeholder="Firma"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  value={rechnungAdresses[0]?.firma}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "firma", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
            </div>

            {/* Wiersz 3: E-Mail (pełna szerokość) */}
            <div
              className="form-row-full"
              style={{ display: "flex", marginBottom: "10px", width: "100%" }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  E-Mail-Adresse*
                </label>
                <input
                  type="email"
                  placeholder="E-Mail-Adresse"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.email")}
                  value={rechnungAdresses[0]?.email}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "email", e.target.value)
                  }
                  disabled={continueStep}
                />
                {showValidation && emailError && (
                  <div style={{ color: "red" }}>
                    Bitte geben Sie eine gültige E-Mail-Adresse ein.
                  </div>
                )}
              </div>
            </div>

            {/* Wiersz 4: Straße und Hausnummer (pełna szerokość) */}
            <div
              className="form-row-full"
              style={{ display: "flex", marginBottom: "10px", width: "100%" }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "100%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Straße und Hausnummer*
                </label>
                <input
                  type="text"
                  placeholder="Straße und Hausnummer"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.streetAndHouse")}
                  value={rechnungAdresses[0]?.streetAndHouse}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(
                      0,
                      "streetAndHouse",
                      e.target.value
                    )
                  }
                  disabled={continueStep}
                />
              </div>
            </div>

            {/* Wiersz 5: PLZ | Ort | Land */}
            <div
              className="form-row-three"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
                width: "100%",
              }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "30%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  PLZ*
                </label>
                <input
                  type="text"
                  placeholder="PLZ"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.zipCode")}
                  value={rechnungAdresses[0]?.zipCode}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "zipCode", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "30%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Ort*
                </label>
                <input
                  type="text"
                  placeholder="Ort"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  {...fieldValidationProps("billing.city")}
                  value={rechnungAdresses[0]?.city}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "city", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "30%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Land
                </label>
                <input
                  type="text"
                  placeholder="Land"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  value={rechnungAdresses[0]?.land}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "land", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
            </div>

            {/* Wiersz 6: Kundenummer | Telefon */}
            <div
              className="form-row-two"
              style={{
                display: "flex",
                marginBottom: "10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "48%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Kundenummer
                </label>
                <input
                  type="text"
                  placeholder="Kundenummer"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  value={rechnungAdresses[0]?.kundenummer}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(
                      0,
                      "kundenummer",
                      e.target.value
                    )
                  }
                  disabled={continueStep}
                />
              </div>
              <div
                className="form-field"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  width: "48%",
                }}
              >
                <label
                  style={{
                    color: "black",
                    marginBottom: "5px",
                    fontSize: "14px",
                  }}
                >
                  Telefon
                </label>
                <input
                  type="text"
                  placeholder="Telefon"
                  style={{
                    height: "40px",
                    background: "#FFFFFF",
                    border: "1px solid #B1B1C5",
                    width: "100%",
                    fontSize: "14px",
                  }}
                  value={rechnungAdresses[0]?.telephone}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    handleRechnungAdresseChange(0, "telephone", e.target.value)
                  }
                  disabled={continueStep}
                />
              </div>
            </div>

            <div
              className="form-spacer"
              style={{ display: "block", width: "100%", height: "32px" }}
            ></div>
          </form>
          {/* Pola wyboru */}
          <div
            className="radio-options-container"
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "10px",
              width: "100%",
            }}
          >
            <div
              className="radio-option"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "auto",
              }}
            >
              <label
                style={{
                  color: "black",
                  marginBottom: "5px",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  style={{ height: "15px", width: "15px", marginRight: "5px" }}
                  checked={!sendToOtherAddress}
                  onChange={() => setSendToOtherAddress(false)}
                />
                Lieferanschrift wie Rechnungsanschrift
              </label>
            </div>
            <div
              className="radio-option"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                width: "auto",
              }}
            >
              <label
                style={{
                  color: "black",
                  marginBottom: "5px",
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="radio"
                  style={{ height: "15px", width: "15px", marginRight: "5px" }}
                  checked={sendToOtherAddress}
                  onChange={() => setSendToOtherAddress(true)}
                />
                Abweichende Lieferadresse
              </label>
            </div>
          </div>
          </div>
        </div>

        <div
          className="flex-container"
          style={{ display: "flex", alignItems: "end" }}
        >
          {/* Napis * Pflichtfelder */}
          <div className="required-text">
            <p>* Pflichtfelder</p>
          </div>
        </div>
        <div
          className="flex-container"
          style={{
            display: "flex",
            alignItems: "end",
            width: "100%",
            margin: "0 auto",
          }}
        >
          {/* {!continueStep && (
            <div
              className="LockConfiguratorButon"
              style={{
                margin: "1% 0 0 0",
                cursor: "pointer",
                backgroundColor: buttonColor,
                transition: "background-color 0.5s ease",
              }}
              special-options
              onClick={(e) => {
                if (handleValidForm()) {
                  setContinueStep(true);
                  const navbarElement =
                    document.getElementById("special-options");
                  navbarElement?.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <div className="text-wrapper">Forsetzen</div>
              <img className="vector" alt="Vector" src={`${backendUrl}/img/Vector.svg`} />
            </div>
          )} */}
        </div>

        {/* Dodatkowy formularz dla adresu dostawy */}
        {sendToOtherAddress && (
          <div>
            <div
              className="order-form-header"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                background: "#005CA9",
                color: "#FFFFFF",
                padding: "10px",
                fontWeight: "bold",
                marginRight: "-20px",
                marginLeft: "-20px",
                marginBottom: "20px",
              }}
            >
              <div style={{ flex: 1 }}>LIFERADRESSE</div>
              <div>2/2</div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <form>
                {/* Wiersz 1: Vorname | Nachname */}
                <div
                  className="form-row-two"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "48%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Vorname*
                    </label>
                    <input
                      type="text"
                      placeholder="Vorname"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      {...fieldValidationProps("delivery.vorname")}
                      value={liferAdresse[0]?.vorname}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "vorname", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "48%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Nachname*
                    </label>
                    <input
                      type="text"
                      placeholder="Nachname"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      {...fieldValidationProps("delivery.nachname")}
                      value={liferAdresse[0]?.nachname}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "nachname", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                </div>

                {/* Wiersz 2: Firma (pełna szerokość) */}
                <div
                  className="form-row-full"
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "100%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Firma
                    </label>
                    <input
                      type="text"
                      placeholder="Firma"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      value={liferAdresse[0]?.firma}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "firma", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                </div>

                {/* Wiersz 3: Straße und Hausnummer (pełna szerokość) */}
                <div
                  className="form-row-full"
                  style={{
                    display: "flex",
                    marginBottom: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "100%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Straße und Hausnummer*
                    </label>
                    <input
                      type="text"
                      placeholder="Straße und Hausnummer"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      {...fieldValidationProps("delivery.streetAndHouse")}
                      value={liferAdresse[0]?.streetAndHouse}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "streetAndHouse", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                </div>
                <div
                  className="form-row-three"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                    width: "100%",
                  }}
                >
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "30%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      PLZ*
                    </label>
                    <input
                      type="text"
                      placeholder="PLZ"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      {...fieldValidationProps("delivery.zipCode")}
                      value={liferAdresse[0]?.zipCode}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "zipCode", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "30%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Ort*
                    </label>
                    <input
                      type="text"
                      placeholder="Ort"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      {...fieldValidationProps("delivery.city")}
                      value={liferAdresse[0]?.city}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "city", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                  <div
                    className="form-field"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      width: "30%",
                    }}
                  >
                    <label
                      style={{
                        color: "black",
                        marginBottom: "5px",
                        fontSize: "14px",
                      }}
                    >
                      Land
                    </label>
                    <input
                      type="text"
                      placeholder="Land"
                      style={{
                        height: "40px",
                        background: "#FFFFFF",
                        border: "1px solid #B1B1C5",
                        width: "100%",
                        fontSize: "14px",
                      }}
                      value={liferAdresse[0]?.land}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleLiferAdresse(0, "land", e.target.value)
                      }
                      disabled={continueStep}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <SpecialOptions disabled={true} />

      <div className="bottom-section">
        {/* lewa kolumna: powrót */}
        <div className="back-container">
          <Link to={"/3"}>
            <div className="LockConfiguratorButon button-secondary">
              <div className="text-wrapper1">Zurück</div>
            </div>
          </Link>
        </div>

        {/* prawa kolumna: regulamin nad przyciskami */}
        <div className="right-col">
          <div className="accept-block">
            <label className="accept-wrapper">
              <div className={`accept-inner ${acceptAlert && !accept ? "accept-error" : ""}`}>
                <input
                  className="accept-checkbox"
                  type="checkbox"
                  name="accept"
                  id="accept"
                  checked={accept}
                  onChange={(e) => setAccept(e.target.checked)}
                />
                <div className="accept-text">
                  Ich habe die&nbsp;
                  <a href="https://www.wplusm.de/de/agb/" target="_blank" rel="noreferrer">
                    Allgemeinen Geschäftsbedingungen
                  </a>
                  &nbsp; gelesen und akzeptiert, ebenfalls habe ich die&nbsp;
                  <a href="https://www.wplusm.de/de/widerrufsbelehrung/" target="_blank" rel="noreferrer">
                    Widerrufsbelehrung
                  </a>
                  &nbsp; sowie die Datenschutzbestimmung zur Kenntnis genommen.
                </div>
              </div>
            </label>
          </div>

          {/* przyciski */}
          <div className="buttons-container LockConfiguratorButons">
            {!waitForSend && (
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <div
                  className="LockConfiguratorButon"
                  style={{
                    cursor: "pointer",
                    backgroundColor: buttonColor,
                    transition: "background-color 0.5s ease",
                  }}
                  onClick={(e) => {
                    if (accept === true) {
                      if (handleValidForm()) {
                        handleEmailSendOrder();
                      }
                    } else {
                      setAcceptAlert(true);
                    }
                  }}
                >
                  <div className="text-wrapper">Kostenpflichtig bestellen</div>
                  <img className="vector" alt="Vector" src={`${backendUrl}/img/Vector.svg`} />
                </div>
                <div
                  className="LockConfiguratorButon button-secondary"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    if (accept) {
                      if (handleValidForm()) {
                        handleEmailSendContact();
                      }
                    } else {
                      setAcceptAlert(true);
                    }
                  }}
                >
                  <div className="text-wrapper" style={{ color: "#005CA9" }}>
                    Anfrage versenden
                  </div>
                  <img className="vector" style={{ width: "20.5px" }} alt="Vector" src={`${backendUrl}/img/mail.svg`} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {waitForSend && !sendEmail && <div className={true ? "loader" : ""}></div>}
      {waitForSend && sendEmail && (
        <img style={{ width: "50px" }} alt="Email" src={`${backendUrl}/img/email.png`} />
      )}
    </>
  );
};

export default OrderForm;
